module.exports = __webpack_public_path__ + "img/feature_e02.7475c654.svg";